module.exports = __webpack_public_path__ + "static/media/cto-full-logo.130e2b98.png";